
export default {
  mounted() {
    this.$nextTick(() => {
      this.$gsap.set(this.$refs.arrows, {
        transformOrigin: 'center',
      })
      this.$gsap.fromTo(
        this.$refs.arrows,
        {
          rotate: 0,
        },
        {
          rotation: 360,
          duration: 13,
          repeat: -1,
          ease: 'linear',
        }
      )
    })
  },
}
